import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AdminAuthProvider } from './auth/AdminAuthProvider'
import { PwaProvider } from './lib/pwa'
import { ThemeProvider } from './state/ThemeProvider'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <PwaProvider>
          <AdminAuthProvider>
            <App />
          </AdminAuthProvider>
        </PwaProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
